export default defineAppConfig({
	ui: {
		colors: {
			primary: 'prim',
			neutral: 'slate',
			secondary: 'acc',
			warning: 'warn',
			danger: 'orange',
		},
		input: {
			defaultVariants: {
				size: 'lg',
			},
			slots: {
				root: 'flex',
				base: 'rounded-lg',
			},
			variants: {
				size: {
					xl: {
						base: 'px-0 py-2',
					},
				},
			},
		},
		button: {
			defaultVariants: {
				size: 'lg',
			},
			slots: {
				base: 'rounded-lg hover:cursor-pointer',
			},
		},
		select: {
			defaultVariants: {
				size: 'lg',
			},
			slots: {
				base: 'rounded-lg flex w-full',
			},
		},
		selectMenu: {
			defaultVariants: {
				size: 'lg',
			},
			slots: {
				base: 'rounded-lg flex w-full',
			},
		},
		textarea: {
			slots: {
				root: 'flex',
				base: 'rounded-lg',
			},
		},
		slideover: {
			variants: {
				side: {
					right: {
						content: 'max-w-xl',
					},
				},
			},
		},
		table: {
			slots: {
				tr: 'hover:cursor-pointer',
			},
		},
	},
})
